import { Component } from 'react'
import log from '../lib/log'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    log.error('ErrorBoundary', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return <>error: 15600</>
    }

    return this.props.children
  }
}

export default ErrorBoundary
